"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.socketSaga = socketSaga;
var _effects = require("redux-saga/effects");
var _user = require("../../user");
var types = _interopRequireWildcard(require("./types"));
var _actions = require("./actions");
var _functions = require("../../../utils/functions");
var _selectors = require("./selectors");
var _helpers = require("../../../utils/helpers");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function startSocketSaga(_ref) {
  let {
    payload: {
      socketUrl,
      socketId
    }
  } = _ref;
  return function* () {
    try {
      const token = yield (0, _effects.select)(_user.selectToken);
      (0, _functions.throwErrorIfIsNotCondition)(token, 'Token is empty (startSocketSaga)');
      const connectUrl = yield (0, _effects.call)(() => "".concat(socketUrl, "/?auth=").concat(token));
      const newSocket = yield (0, _effects.call)(() => new WebSocket(connectUrl, []));
      yield (0, _effects.put)((0, _actions.addSocketAction)({
        id: socketId,
        socket: newSocket
      }));
    } catch (error) {
      // eslint-disable-next-line no-console
      yield (0, _effects.call)(() => console.error(error.message));
    }
  }();
}
function disconnectSocketSaga(_ref2) {
  let {
    payload: {
      socketId,
      logPrefix = '',
      hideLogs = true,
      closePrevSocket = false
    }
  } = _ref2;
  return function* () {
    try {
      const socket = yield (0, _effects.select)((0, _selectors.selectSocketById)({
        socketId
      }));
      yield (0, _effects.call)(() => (0, _functions.throwErrorIfIsNotCondition)(socket, 'Socket already disconnected'));
      yield (0, _effects.call)(() => socket.close());
      yield (0, _effects.call)(() => (0, _helpers.getLog)({
        logPrefix,
        hideLogs,
        text: closePrevSocket ? 'Previous socket finally disconnected' : 'Socket finally disconnected'
      }));
      yield (0, _effects.put)((0, _actions.removeSocketAction)({
        id: socketId
      }));
    } catch (error) {
      // eslint-disable-next-line no-console
      yield (0, _effects.call)(() => console.error(error.message));
    }
  }();
}
function reconnectSocketSaga(_ref3) {
  let {
    payload: {
      socketUrl,
      socketId,
      logPrefix = '',
      hideLogs = true
    }
  } = _ref3;
  return function* () {
    try {
      yield (0, _effects.call)(disconnectSocketSaga, {
        payload: {
          socketId,
          logPrefix,
          hideLogs,
          closePrevSocket: true
        }
      });
      yield (0, _effects.call)(startSocketSaga, {
        payload: {
          socketUrl,
          socketId
        }
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      yield (0, _effects.call)(() => console.error(error.message));
    }
  }();
}
function* socketSaga() {
  yield (0, _effects.all)([(0, _effects.takeEvery)(types.START_SOCKET_SAGA, startSocketSaga), (0, _effects.takeEvery)(types.RECONNECT_SOCKET_SAGA, reconnectSocketSaga), (0, _effects.takeEvery)(types.DISCONNECT_SOCKET_SAGA, disconnectSocketSaga)]);
}